import React from "react";
import { Reveal, Eyebrow, BrowserFrame } from "./MarketingUI";
import { TrendingUp, ListChecks, FileBarChart } from "lucide-react";

const cards = [
  { icon: TrendingUp, title: "Executive Brief", desc: "A deterministic, source-grounded summary of what changed." },
  { icon: ListChecks, title: "Operations Dashboard", desc: "My work, legislative activity and monitoring in one view." },
  { icon: FileBarChart, title: "Reports & Analytics", desc: "Operational reporting with CSV export for leadership." },
];

export default function Executive() {
  return (
    <section id="about" className="bg-[#F5F7FA] py-24 sm:py-28" data-testid="executive-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <Reveal><Eyebrow>Executive experience</Eyebrow></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-display text-3xl font-extrabold leading-tight tracking-tight text-brand-ink sm:text-4xl">
              Give leadership the signal — not the noise.
            </h2>
          </Reveal>
        </div>

        <Reveal delay={0.1} className="mt-12">
          <BrowserFrame url="app.govflowstate.com/analytics" testid="executive-screenshot">
            <img src="/marketing/analytics.png" alt="GovFlowState executive analytics — bill counts by status, activity by policy area and session-at-a-glance metrics" className="block w-full" loading="lazy" />
          </BrowserFrame>
        </Reveal>

        <div className="mt-8 grid gap-4 md:grid-cols-3">
          {cards.map((c, i) => (
            <Reveal key={c.title} delay={0.07 * i}>
              <div className="flex h-full items-start gap-4 rounded-2xl border border-brand-line bg-white p-6 shadow-card" data-testid={`executive-card-${i}`}>
                <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-brand-navy">
                  <c.icon className="h-5 w-5 text-white" strokeWidth={1.9} />
                </span>
                <div>
                  <h3 className="font-display text-base font-bold text-brand-ink">{c.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-brand-slate">{c.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
